import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react/components/LiveStreams/Room/Buttons/IconButton";
import { Icon } from "@circle-react-shared/Icon";

interface FullscreenButtonProps {
  isFullscreen: boolean;
  onClick: () => void;
}

export const FullscreenButton = ({
  onClick = noop,
  isFullscreen,
}: FullscreenButtonProps) => (
  <div className="absolute right-7 top-7 z-10">
    <IconButton
      tooltipText={t("live_streams.room.button_tooltips.fullscreen")}
      aria-label={t("live_streams.room.button_tooltips.fullscreen")}
      tooltipPlacement="left"
      onClick={onClick}
      noMargin
    >
      {!isFullscreen && <Icon type="fullscreen" size={24} />}
      {isFullscreen && <Icon type="exit-fullscreen" size={24} />}
    </IconButton>
  </div>
);
